import { ACTIVITY_YMS_EXPORT_RESULT } from 'utils/activityTracking/constants';
import { YMS_EXPORT_STATUS } from 'utils/fenixYms';

const RESULT_BY_STATUS = Object.freeze({
    [YMS_EXPORT_STATUS.SUCCESS]: ACTIVITY_YMS_EXPORT_RESULT.SUCCESS,
    [YMS_EXPORT_STATUS.SUCCESS_WITH_WARNING]: ACTIVITY_YMS_EXPORT_RESULT.SUCCESS_WITH_WARNING,
    [YMS_EXPORT_STATUS.ERROR]: ACTIVITY_YMS_EXPORT_RESULT.ERROR,
});

/**
 * The `result` of a `yms_export.responded` event for a Fenix export status, or `null` when the status is
 * not an outcome (`PENDING`, or anything unknown) - in which case no responded event is sent.
 */
export function mapYmsExportStatusToResult(status) {
    return RESULT_BY_STATUS[status] ?? null;
}

/**
 * `attempt_number` of the attempt that just started, from the transaction's Fenix slice entry: every
 * attempt already on it (backend history plus local ones, what the Timeline shows) except the new
 * pending one `exportStarted` has just pushed, plus one.
 *
 * Best effort by design: it counts what the browser knows at the click, and tracking may never wait.
 * - If the history has not loaded yet (or failed to), earlier attempts are missing from the count.
 * - A refetch can list an init failure twice (the backend row and the local one, neither with a
 *   request id), which the Timeline shows twice too.
 * - A failure that the backend did not record (400 / 5xx / network) has no backend row, so after a
 *   reload it is no longer counted and a later attempt can repeat its number.
 * - A 409 attempt is dropped from the slice, so the next attempt repeats its number.
 * Attempts stay orderable by `occurred_at`, and paired by `correlation_id`.
 *
 * @param {object} fenixEntry the transaction's `fenixYms.byTransactionId` entry
 */
export function resolveYmsExportAttemptNumber(fenixEntry) {
    const attempts = Array.isArray(fenixEntry?.attempts) ? fenixEntry.attempts : [];
    const pendingId = fenixEntry?.localPendingId ?? null;
    return attempts.filter((attempt) => attempt?.id !== pendingId).length + 1;
}
